// Angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Actions, ofType } from '@ngrx/effects';
// NGRX
import { select, Store } from '@ngrx/store';
// RxJS
import { Observable, Subject, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import {
  LayoutUtilsService,
  MessageType,
} from '../../../../../../core/_base/crud';
// AppState
import { AppState } from '../../../../../../core/reducers';
import {
  GCActionFail,
  GCActionSuccess,
  GConfig,
  GConfigActionTypes,
  GConfigBulkUpdate,
  selectGConfigById,
} from '../../../../../../core/rex';

@Component({
  selector: 'kt-diakinisis',
  templateUrl: './diakinisis.component.html',
  styleUrls: ['./diakinisis.component.scss'],
})
export class DiakinisisComponent implements OnInit, OnDestroy {
  @Input() saveEvent: Observable<void>;

  diak_api_endpoint: GConfig = new GConfig();
  diak_account_code: GConfig = new GConfig();
  diak_user_alias: GConfig = new GConfig();
  diak_credential_value: GConfig = new GConfig();
  diak_api_key: GConfig = new GConfig();

  hasFormErrors = false;
  serverError: Subject<any>;
  diakForm: UntypedFormGroup;
  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store<AppState>,
    private layoutUtilsService: LayoutUtilsService,
    private actions$: Actions,
    private diakFB: UntypedFormBuilder
  ) {}

  ngOnInit() {
    this.serverError = new Subject();
    this.serverError.next(false);

    const ss = this.saveEvent.subscribe(() => this.save());
    this.subscriptions.push(ss);

    this.fetchDataFromStore();
    this.createForm();

    const sss = this.actions$
      .pipe(
        ofType<GCActionSuccess>(GConfigActionTypes.GCActionSuccess),
        tap(({ payload }) => {
          this.layoutUtilsService.showActionNotification(
            payload.result,
            MessageType.Update,
            5000,
            true,
            true
          );
        })
      )
      .subscribe();
    this.subscriptions.push(sss);

    const sf = this.actions$
      .pipe(
        ofType<GCActionFail>(GConfigActionTypes.GCActionFail),
        tap(({ payload }) => {
          if (
            // eslint-disable-next-line no-prototype-builtins
            payload.result.hasOwnProperty('error') &&
            // eslint-disable-next-line no-prototype-builtins
            payload.result.error.hasOwnProperty('detail')
          ) {
            this.serverError.next(payload.result.error.detail);
          } else {
            this.serverError.next(
              'Συνέβη ένα σφάλμα με την αποθήκευση των δεδομένων. Παρακαλώ ξαναπροσπαθήστε.'
            );
          }
        })
      )
      .subscribe();
    this.subscriptions.push(sf);
  }

  fetchDataFromStore() {
    this.store
      .pipe(
        select(selectGConfigById('hidden__DIAK_API_ENDPOINT')),
        take(1),

        tap(res => (this.diak_api_endpoint = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__DIAK_ACCOUNT_CODE')),
        take(1),
        tap(res => (this.diak_account_code = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__DIAK_USER_ALIAS')),
        take(1),
        tap(res => (this.diak_user_alias = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__DIAK_CREDENTIAL_VALUE')),
        take(1),
        tap(res => (this.diak_credential_value = { ...res }))
      )
      .subscribe();

    this.store
      .pipe(
        select(selectGConfigById('hidden__DIAK_API_KEY')),
        take(1),
        tap(res => (this.diak_api_key = { ...res }))
      )
      .subscribe();
  }

  createForm() {
    const fgd: { [k: string]: any } = {
      diak_api_endpoint: [this.diak_api_endpoint.value, Validators.required],
      diak_account_code: [this.diak_account_code.value, Validators.required],
      diak_user_alias: [this.diak_user_alias.value, Validators.required],
      diak_credential_value: [
        this.diak_credential_value.value,
        Validators.required,
      ],
      diak_api_key: [this.diak_api_key.value, Validators.required],
    };

    this.diakForm = this.diakFB.group(fgd);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  save() {
    this.hasFormErrors = false;
    this.serverError.next(false);

    const controls = this.diakForm.controls;
    if (this.diakForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );

      this.hasFormErrors = true;
      return;
    }

    this.diak_api_endpoint.value = controls.diak_api_endpoint.value;
    this.diak_account_code.value = controls.diak_account_code.value;
    this.diak_user_alias.value = controls.diak_user_alias.value;
    this.diak_credential_value.value = controls.diak_credential_value.value;
    this.diak_api_key.value = controls.diak_api_key.value;

    const buo: { [key: string]: any } = {};
    buo[this.diak_api_endpoint.identifier] = this.diak_api_endpoint.value;
    buo[this.diak_account_code.identifier] = this.diak_account_code.value;
    buo[this.diak_user_alias.identifier] = this.diak_user_alias.value;
    buo[this.diak_credential_value.identifier] =
      this.diak_credential_value.value;
    buo[this.diak_api_key.identifier] = this.diak_api_key.value;

    this.store.dispatch(new GConfigBulkUpdate({ values: buo }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onAlertClose($event) {
    this.hasFormErrors = false;
    this.serverError.next(false);
  }
}
